import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { NearOurNetworkPage, NearOurNetworkPageProps } from "./NearOurNetworkPage";

export const EMPTY_PAGE_CONTENT: NearOurNetworkPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/help-safety/near-our-network";

export const NearOurNetworkPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<NearOurNetworkPageProps>("near_our_network", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <NearOurNetworkPage {...routeProps} {...content} />;
};
